import { all, call, takeEvery, fork } from "redux-saga/effects";
import newRequestFunction from "../Utils/newSGF";

import {
  APPROVE_SUCCESS_STORY,
  CREATE_SUCCESS_STORY,
  FETCH_ALL_SUCCESS_STORY,
  FETCH_SUCCESS_STORY_BY_ID,
  FETCH_SUCCESS_STORY_WITHOUT_PAGINATION,
  FETCH_TOTAL_SUCCESS_STORY,
  UPDATE_SUCCESS_STORY,
} from "../ActionTypes";

import {
  addSuccessStoryFailure,
  addSuccessStorySuccess,
  approveSuccessStoryFailure,
  approveSuccessStorySuccess,
  fetchSuccessStoryByIdFailure,
  fetchSuccessStoryByIdSuccess,
  fetchSuccessStoryFailure,
  fetchSuccessStorySuccess,
  fetchSuccessStoryWithoutPaginationFailure,
  fetchSuccessStoryWithoutPaginationSuccess,
  fetchTotalSuccessStoryFailure,
  fetchTotalSuccessStorySuccess,
  updateSuccessStoryFailure,
  updateSuccessStorySuccess,
} from "../Actions";

import {
  approveSuccessStoryApi,
  createSuccessStoryApi,
  getAllSuccessStoryApi,
  getSuccessStoryByIdApi,
  getSuccessStoryWithoutPaginationApi,
  getTotalSuccessStoryApi,
  updateSuccessStoryApi,
} from "../Api";

// Requests

const createSuccessStoryRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    addSuccessStorySuccess,
    addSuccessStoryFailure,
    createSuccessStoryApi,
    payload
  );
};

const getAllSuccessStoryRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    fetchSuccessStorySuccess,
    fetchSuccessStoryFailure,
    getAllSuccessStoryApi,
    payload
  );
};

const getSuccessStoryByIdRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    fetchSuccessStoryByIdSuccess,
    fetchSuccessStoryByIdFailure,
    getSuccessStoryByIdApi,
    payload
  );
};

const updateSuccessStoryRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    updateSuccessStorySuccess,
    updateSuccessStoryFailure,
    updateSuccessStoryApi,
    payload
  );
};

const approveSuccessStoryRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    approveSuccessStorySuccess,
    approveSuccessStoryFailure,
    approveSuccessStoryApi,
    payload
  );
};

const fetchSuccessStoryNoPaginationRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    fetchSuccessStoryWithoutPaginationSuccess,
    fetchSuccessStoryWithoutPaginationFailure,
    getSuccessStoryWithoutPaginationApi,
    payload
  );
};

const fetchTotalSuccessStoryRequest = function* ({ payload }) {
  yield call(
    newRequestFunction,
    fetchTotalSuccessStorySuccess,
    fetchTotalSuccessStoryFailure,
    getTotalSuccessStoryApi,
    payload
  );
};

// Watchers

const createStoryWatcher = function* () {
  yield takeEvery(CREATE_SUCCESS_STORY, createSuccessStoryRequest);
};

const getAllStoryWatcher = function* () {
  yield takeEvery(FETCH_ALL_SUCCESS_STORY, getAllSuccessStoryRequest);
};

const getStoryByIdWatcher = function* () {
  yield takeEvery(FETCH_SUCCESS_STORY_BY_ID, getSuccessStoryByIdRequest);
};

const updateStoryWatcher = function* () {
  yield takeEvery(UPDATE_SUCCESS_STORY, updateSuccessStoryRequest);
};

const approveStoryWatcher = function* () {
  yield takeEvery(APPROVE_SUCCESS_STORY, approveSuccessStoryRequest);
};

const getStoryNoPaginationWatcher = function* () {
  yield takeEvery(
    FETCH_SUCCESS_STORY_WITHOUT_PAGINATION,
    fetchSuccessStoryNoPaginationRequest
  );
};

const getTotalStoryWatcher = function* () {
  yield takeEvery(FETCH_TOTAL_SUCCESS_STORY, fetchTotalSuccessStoryRequest);
};

export default function* rootSaga() {
  yield all([
    fork(createStoryWatcher),
    fork(getAllStoryWatcher),
    fork(getStoryByIdWatcher),
    fork(updateStoryWatcher),
    fork(approveStoryWatcher),
    fork(getStoryNoPaginationWatcher),
    fork(getTotalStoryWatcher),
  ]);
}
